// frontend/src/pages/PersonaWorkshop/useCoachSession.ts
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '@/services/apiClient'
import type { CoachSession } from '@/types/personaCoach'

const EMPTY: CoachSession = { session_id: null, turns: [] }

export function coachSessionKey(personaId: string) {
  return ['coach', 'session', personaId] as const
}

export function useCoachSession(personaId: string) {
  const qc = useQueryClient()

  const sessionQuery = useQuery({
    queryKey: coachSessionKey(personaId),
    queryFn: () => apiClient.get<CoachSession>(`/api/personas/${personaId}/coach/session`),
    staleTime: 0,
  })

  const statusQuery = useQuery({
    queryKey: ['coach', 'status', personaId],
    queryFn: () => apiClient.get<{ available: boolean }>(`/api/personas/${personaId}/coach/status`),
    staleTime: 60_000,
  })

  const startFresh = async () => {
    const fresh = await apiClient.post<CoachSession>(`/api/personas/${personaId}/coach/session`, {})
    qc.setQueryData(coachSessionKey(personaId), fresh)
  }

  return {
    session: sessionQuery.data ?? EMPTY,
    isLoading: sessionQuery.isLoading,
    status: statusQuery.data,
    startFresh,
  }
}
